import React, { useContext, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "../sass/Header.scss";
import { isMobile } from "react-device-detect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import { LoginContext } from "./context/LoginContext";

const AppHeader = () => {
  const { name } = useContext(LoginContext);
  if (name) {
    localStorage.setItem("name", JSON.stringify(name));
  }
  const { addName } = useContext(LoginContext);
  const [open, setOpen] = useState(false);
  let NAME;
  if (!name) {
    NAME = JSON.parse(localStorage.getItem("name"));
  }
  return (
    <div>
      <div className={isMobile ? "Header mobile" : "Header"}>
        <NavLink to="/" className="Brand">
          earth
          <br />
          <strong>sights</strong>
        </NavLink>

        {!isMobile ? (
          <span className="HeaderMenu">
            <NavLink to="/about">About</NavLink>
            <NavLink to="/how-it-works">How it works</NavLink>
            {/* <NavLink to="/">Contact</NavLink>
            {(name || NAME !== null) && (
              <NavLink
                to="/"
                onClick={() => {
                  addName(null);
                  localStorage.removeItem("name");
                }}
              >
                Logout
              </NavLink>
            )}
            {!name && NAME == undefined && <NavLink to="/login">Login</NavLink>}
            <NavLink to="/">
              {name
                ? name[0].toUpperCase() + name[1].toUpperCase()
                : NAME !== null
                ? NAME[0].toUpperCase() + NAME[1].toUpperCase()
                : "Dummy"}
            </NavLink> */}
          </span>
        ) : (
            ""
          // <span onClick={() => setOpen(!open)}>
          //   <FontAwesomeIcon icon={open ? faXmark : faBars} size="lg" />
          // </span>
        )}
      </div>

      {/* {isMobile && (
        <div className={open ? "sidemenu active" : "sidemenu"}>
          <NavLink to="/about">About</NavLink>
          <NavLink to="/how-it-works">How it works</NavLink>
          <NavLink to="/">Pricing</NavLink>
          <NavLink to="/">Contact</NavLink>
          <NavLink to="/login">Login</NavLink>
        </div>
      )} */}
    </div>
  );
};

export default AppHeader;
